module.exports = __webpack_public_path__ + "static/landscapepainting.12bd68d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landscapepainting.jpg
// module id = 854
// module chunks = 135882870033682